/**
 * Origen del host ACV para postMessage con targetOrigin explícito.
 * Prioridad: cadena de ancestros del iframe (Chrome) → env → referrer.
 * Sin un origen válido, postMessage no llega al padre (fallo silencioso).
 */
export function getAcvParentOriginForPostMessage(): string | null {
  try {
    if (typeof window !== 'undefined' && window.parent !== window) {
      const ao = (window.location as unknown as { ancestorOrigins?: DOMStringList })
        .ancestorOrigins;
      if (ao && ao.length > 0) {
        return ao[0];
      }
    }
  } catch {
    // ignore
  }

  try {
    const configured = (
      ((window as unknown as { REACT_APP_ACV_PARENT_APP?: string }).REACT_APP_ACV_PARENT_APP as string) ||
      (import.meta.env?.VITE_ACV_PARENT_APP as string) ||
      ''
    )
      .split(',')
      .map((origin) => origin.trim())
      .filter(Boolean);

    if (configured.length > 0) {
      return configured[0];
    }
  } catch {
    // ignore
  }

  try {
    if (document.referrer) {
      return new URL(document.referrer).origin;
    }
  } catch {
    // ignore
  }

  return null;
}
